/* eslint-disable react/prop-types */ // TODO: add props
import DragAndDropArea from 'core/components/DragAndDropArea';
import s from './styles.scss';
import {
  getDraggableAnnotations,
  getDropzoneAnnotations,
} from 'admin/domains/examQuestion/components/Question/dragAndDropAnnotationFormHooks';

export const DragAndDropExample = ({ question }) => {
  const dndMap = question
    .get('fields')
    .map((r) => ({
      fieldId: r.get('id'),
      optionId: r.get('correct_options').first(),
      // TODO: Resolve: this is a list/array of correct answers,
      // but we only display the first correct option per field for the example answer.
      // Logically this is correct but it may not render the answer that looks the nicest in the UI.
    }))
    .toJS()
    .reduce((acc, item) => ({ ...acc, [item.fieldId]: item.optionId }), {});

  const dndCorrectnessMap = question
    .get('fields')
    .map((r) => ({
      fieldId: r.get('id'),
      isCorrect: true,
    }))
    .toJS()
    .reduce((acc, item) => ({ ...acc, [item.fieldId]: item.isCorrect }), {});

  const draggableAnnotations = getDraggableAnnotations(question);
  const dropzoneAnnotations = getDropzoneAnnotations(question);

  return (
    <div className={s.wrapper}>
      <div className={s.dragAndDropExample}>
        <div className={s.dndArea}>
          <DragAndDropArea
            draggableAnnotations={draggableAnnotations}
            dropzoneAnnotations={dropzoneAnnotations}
            imageUrl={question.get('image_url')}
            onDraggableRelocated={() => {}}
            draggableToContainingDropzoneMap={dndMap}
            dndCorrectnessMap={dndCorrectnessMap}
          />
        </div>
      </div>
      <span className={s.checkmark} />
    </div>
  );
};
